import * as Sentry from "@sentry/vue";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (idCart, idMessage) {
  const routeLang = useRouteLang();

  try {
    return await $apiFetch(API_ENDPOINTS.ESHOP_CHECKOUT_CART_MESSAGE_ID_TRANSLATION, {
      method: 'GET',
      path: { idCart, idMessage },
      params: {
        locale: routeLang.locale.value
      }
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
}
